export default __webpack_public_path__ + "static/media/filter_icon_shop.60faef42.svg";